import script from "./EpProcEditPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EpProcEditPage.vue?vue&type=script&setup=true&lang=js"

import "./EpProcEditPage.vue?vue&type=style&index=0&id=2b7738f4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b7738f4"]])

export default __exports__